import React, { FC } from "react";
import { EmptyDashboard } from "@modules/dashboards/empty/empty";
import { getEmptyTextBlock } from "@modules/dashboards/empty/common";

const getEmptySvg = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="499" viewBox="0 0 1240 499" fill="none">
            <path d="M91.6719 330L1203.67 330" stroke="#CCD9E0" />
            <path d="M91.6719 278L1203.67 278" stroke="#CCD9E0" />
            <path d="M91.6719 226L1203.67 226" stroke="#CCD9E0" />
            <path d="M91.6719 174L1203.67 174" stroke="#CCD9E0" />
            <path d="M91.6719 122L1203.67 122" stroke="#CCD9E0" />
            <path d="M91.6719 70L1203.67 70" stroke="#CCD9E0" />
            <path d="M91.6719 18L1203.67 18" stroke="#CCD9E0" />
            <path d="M91.6719 0V390H1203.67" stroke="#CCD9E0" stroke-miterlimit="3.93356" />
            <rect x="91.6719" y="414" width="18" height="8" rx="2" fill="#EAEAEB" />
            <rect x="127.672" y="414" width="18" height="8" rx="2" fill="#EAEAEB" />
            <rect x="163.672" y="414" width="18" height="8" rx="2" fill="#EAEAEB" />
            <rect x="199.672" y="414" width="18" height="8" rx="2" fill="#EAEAEB" />
            <rect x="235.672" y="414" width="18" height="8" rx="2" fill="#EAEAEB" />
            <rect x="271.672" y="414" width="18" height="8" rx="2" fill="#EAEAEB" />
            <rect x="307.672" y="414" width="18" height="8" rx="2" fill="#EAEAEB" />
            <rect x="343.672" y="414" width="18" height="8" rx="2" fill="#EAEAEB" />
            <rect x="379.672" y="414" width="18" height="8" rx="2" fill="#EAEAEB" />
            <rect x="415.672" y="414" width="18" height="8" rx="2" fill="#EAEAEB" />
            <rect x="451.672" y="414" width="18" height="8" rx="2" fill="#EAEAEB" />
            <rect x="487.672" y="414" width="18" height="8" rx="2" fill="#EAEAEB" />
            <rect x="523.672" y="414" width="18" height="8" rx="2" fill="#EAEAEB" />
            <rect x="559.672" y="414" width="18" height="8" rx="2" fill="#EAEAEB" />
            <rect x="595.672" y="414" width="18" height="8" rx="2" fill="#EAEAEB" />
            <rect x="631.672" y="414" width="18" height="8" rx="2" fill="#EAEAEB" />
            <rect x="667.672" y="414" width="18" height="8" rx="2" fill="#EAEAEB" />
            <rect x="703.672" y="414" width="18" height="8" rx="2" fill="#EAEAEB" />
            <rect x="739.672" y="414" width="18" height="8" rx="2" fill="#EAEAEB" />
            <rect x="775.672" y="414" width="18" height="8" rx="2" fill="#EAEAEB" />
            <rect x="811.672" y="414" width="18" height="8" rx="2" fill="#EAEAEB" />
            <rect x="847.672" y="414" width="18" height="8" rx="2" fill="#EAEAEB" />
            <rect x="883.672" y="414" width="18" height="8" rx="2" fill="#EAEAEB" />
            <rect x="919.672" y="414" width="18" height="8" rx="2" fill="#EAEAEB" />
            <rect x="955.672" y="414" width="18" height="8" rx="2" fill="#EAEAEB" />
            <rect x="991.672" y="414" width="18" height="8" rx="2" fill="#EAEAEB" />
            <rect x="1027.67" y="414" width="18" height="8" rx="2" fill="#EAEAEB" />
            <rect x="1063.67" y="414" width="18" height="8" rx="2" fill="#EAEAEB" />
            <rect x="1099.67" y="414" width="18" height="8" rx="2" fill="#EAEAEB" />
            <rect x="1135.67" y="414" width="18" height="8" rx="2" fill="#EAEAEB" />
            <rect x="1171.67" y="414" width="18" height="8" rx="2" fill="#EAEAEB" />
            <path
                d="M102.672 389H146.672L171.172 327H255.172L317.672 120L378.172 170H552.172L695.172 120V389H754.172L846.172 13H1015.67L1123.17 389"
                stroke="#EAEAEB"
                stroke-width="2"
            />
            <path
                d="M122.672 388.5H160.172L191.672 307.5L199.172 388.5L226.172 347.5H243.672L302.672 148L361.172 201.5H498.172L634.172 155.5V367.5L677.672 388.5L763.672 40.5H897.172L983.172 275H1070.67L1103.17 388.5"
                stroke="#EAEAEB"
                strokeWidth="2"
            />
            <circle cx="101.672" cy="458" r="7" fill="#EAEAEB" />
            <rect x="119.672" y="454" width="40" height="8" rx="2" fill="#EAEAEB" />
            <circle cx="187.672" cy="458" r="7" fill="#EAEAEB" />
            <rect x="205.672" y="454" width="40" height="8" rx="2" fill="#EAEAEB" />
            <g clipPath="url(#clip0_6720_60535)">
                <rect y="10" width="76" height="12" rx="4" fill="#EAEAEB" />
                <rect y="62" width="76" height="12" rx="4" fill="#EAEAEB" />
                <rect y="114" width="76" height="12" rx="4" fill="#EAEAEB" />
                <rect y="166" width="76" height="12" rx="4" fill="#EAEAEB" />
                <rect y="218" width="76" height="12" rx="4" fill="#EAEAEB" />
                <rect y="270" width="76" height="12" rx="4" fill="#EAEAEB" />
                <rect y="322" width="76" height="12" rx="4" fill="#EAEAEB" />
                <rect y="374" width="76" height="12" rx="4" fill="#EAEAEB" />
            </g>
            <rect width="1240" height="499" fill="url(#paint0_linear_6720_60535)" />
            <defs>
                <linearGradient
                    id="paint0_linear_6720_60535"
                    x1="620"
                    y1="-36.9619"
                    x2="620"
                    y2="452.49"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="white" stop-opacity="0" />
                    <stop offset="1" stop-color="white" />
                </linearGradient>
                <clipPath id="clip0_6720_60535">
                    <rect width="76" height="384" fill="white" transform="translate(0 6)" />
                </clipPath>
            </defs>
        </svg>
    );
};

interface EmptyProps {
    name: string;
}

export const Empty: FC<EmptyProps> = ({ name }) => {
    const emptyName = `Затраты за ${name}`;
    return <EmptyDashboard name={emptyName} emptyTextBlock={getEmptyTextBlock()} content={getEmptySvg()} />;
};